module.exports = __webpack_public_path__ + "static/media/projectweek-2.79983469.jpg";